import { UPDropdownItem } from 'components/dropdown';
import { t } from 'i18next';
import {
  EMPLOYEES__STUDENT_FULL,
  EMPLOYEES__FLEXI_FULL,
  EMPLOYEES__EXTRA_FULL,
  EMPLOYEES__LABOURER_FULL,
  EMPLOYEES__SERVANT_FULL,
} from 'translations/constants';

export enum ContractTypes {
  STUD = 'STUD',
  FLEX = 'FLEX',
  ARB = 'ARB',
  EXT = 'EXT',
  BED = 'BED',
}

export const ContractTypeOptions = (): UPDropdownItem[] => {
  return [
    {
      label: t(EMPLOYEES__STUDENT_FULL),
      value: ContractTypes.STUD,
    },
    {
      label: t(EMPLOYEES__FLEXI_FULL),
      value: ContractTypes.FLEX,
    },
    {
      label: t(EMPLOYEES__LABOURER_FULL),
      value: ContractTypes.ARB,
    },
    {
      label: t(EMPLOYEES__EXTRA_FULL),
      value: ContractTypes.EXT,
    },
    {
      label: t(EMPLOYEES__SERVANT_FULL),
      value: ContractTypes.BED,
    },
  ];
};
